// =============================================================================
// src/features/explore/explore-vote-popup.ts — HTML do popup de ranking ao clicar
//   numa regiao com um modo de votos ativo (estilo Datapedia).
//
// Cabecalho: "<NOME> ficou na <Nª> posição e obteve <votos> de um total de <total>
//   votos válidos em <REGIÃO>." + lista rolavel de TODOS os candidatos
//   (posicao · NOME (partido) · votos · %), com a linha do selecionado realcada.
//   O conteudo entra num L.popup (ver explore-map.ts). Dados internos (nomes/cores
//   do proprio app) — sem HTML de terceiros.
//
// SRP: so geracao de string HTML. Sem DOM, sem Leaflet, sem dataset.
// =============================================================================

import { bubbleColorOf, type RegionVoteEntry } from './explore-vote-data';
import { formatVotos, formatPercent } from './explore-vote-anim';

/** Linha de um candidato no ranking (realca a linha selecionada). */
function rankingRow(entry: RegionVoteEntry, selectedId: string): string {
  const sel = entry.cand.id === selectedId ? ' is-sel' : '';
  const color = bubbleColorOf(entry.cand.party);
  return (
    `<div class="exp-vp-row${sel}">` +
    `<span class="exp-vp-pos">${entry.posicao}º</span>` +
    `<b class="exp-vp-name">${entry.cand.nome}</b> ` +
    `<span class="exp-vp-party" style="color:${color}">(${entry.cand.party})</span>` +
    `<span class="exp-vp-num">${formatVotos(entry.votos)} votos · ${formatPercent(entry.pct)}</span>` +
    `</div>`
  );
}

/**
 * HTML completo do popup de ranking. `selectedId` destaca o candidato escolhido; sem
 * ele (ou id orfao) o destaque/cabecalho usam o 1º colocado. `entries` vazio → ''.
 */
export function buildVoteRankingHtml(
  entries: readonly RegionVoteEntry[],
  regionName: string,
  totalValidos: number,
  selectedId: string | null,
): string {
  const selected = entries.find((e) => e.cand.id === selectedId) ?? entries[0];
  if (!selected) return '';
  const head =
    `<div class="exp-vp-head"><b>${selected.cand.nome}</b> ficou na <b>${selected.posicao}ª</b> posição ` +
    `e obteve <b>${formatVotos(selected.votos)}</b> de um total de ${formatVotos(totalValidos)} ` +
    `votos válidos em <b>${regionName}</b>.</div>`;
  const rows = entries.map((entry) => rankingRow(entry, selected.cand.id)).join('');
  return `${head}<div class="exp-vp-title">Ranking</div><div class="exp-vp-list">${rows}</div>`;
}
